import { createContext, useContext } from 'react';
export type Account = {
  id: string;
  displayName: string;
  label: string;
  identityLabel?: string;
  wallet: string | null;
  logout: () => void;
  rename: (name: string) => Promise<void>;
};
export const AccountContext = createContext<Account | null>(null);
export const useAccount = () => useContext(AccountContext);
